<template lang="pug">

div

    //- Benutzername
    text-field(label='Benutzername' v-model='username' v-bind:is-required='true')
        field-error(v-bind:validation='validation' attribute="username")

    //- Status
    dropdown-field(
        label='Status'
        v-bind:options='statusOptions'
        v-bind:isRequired='true'
        v-bind:withEmptyOption='false'
        v-model='status'
    )
        field-error(v-bind:validation='validation' attribute="status")


</template>

<script>
    import * as R from 'ramda'
    import DropdownField from '@/components/form/DropdownField.vue'
    import FieldError from '@/components/form/SmartFieldError'
    import TextField from '@/components/form/TextField.vue'
    import { Validator } from 'simple-vue-validator'

    //noinspection JSUnusedGlobalSymbols
    export default {

        components: { DropdownField, FieldError, TextField },

        computed: {

            status: {
                get() { return this.value.status },
                set(value) { this.updateValue('status', value) }
            },

            username: {
                get() { return this.value.username },
                set(value) { this.updateValue('username', value) }
            }

        },

        data() {
            return {
                statusOptions: [
                    { id: 'HAS_ACCESS', name: 'Aktiv' },
                    { id: 'HAS_NO_ACCESS', name: 'Inaktiv' }
                ]
            }
        },

        created() {
            // ggf. Default-Status setzen
            if (!['HAS_ACCESS', 'HAS_NO_ACCESS'].includes(this.status)) {
                this.status = 'HAS_ACCESS'
            }
        },

        methods: {

            updateValue(target, value) {
                this.$emit('input', { ...this.value, [target]: value })
            },

            validate() {
                return this.$validate()
                    .then(R.when(R.equals(false), () => Promise.reject()))
            }

        },

        props: {
            value: {
                type: Object,
                required: true
            }
        },

        validators: {

            status(status) {
                return Validator.value(R.defaultTo('', status))
                    .required('Darf nicht leer sein. Bitte einen Status auswählen')
            },

            username(username) {
                const isUnique = R.composeP(

                    // Pruefen ob ein Benutzer mit dem Benutzernamen vorhanden ist
                    R.ifElse(R.propEq('length', 0), R.always(undefined), R.always('Benutzername bereits vergeben')),

                    // Benutzer mit ID des gerade zu bearbeitenden Users entfernen
                    R.reject(R.propEq('id', this.value.id)),

                    // Filtern nach Benutzernamen
                    R.filter(R.propEq('username', this.username)),

                    // Benutzer suchen
                    () => this.$store.dispatch('users/loadAll', { params: { username }, force: true }),
                )

                return Validator.value(R.defaultTo('', username))
                    .required('Darf nicht leer sein. Bitte eine gültige Benutzernamen eingeben')
                    .custom(isUnique)
            }

        }

    }

</script>
